customElements.component_sku_level = 'front-back-image-helper-sku-level';

if (!customElements.get(customElements.component_sku_level)) {
  class FrontBackImageHelperSkuLevel extends HTMLElement {
    constructor() {
      super();
      this.settings = null;
      this.frontInput = null;
      this.backInput = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      document.removeEventListener('product-option-change', this.handleProductOptionChange.bind(this));
    }

    init() {
      this.settings = window.front_back_image_helper_sku_level.variants;
      
      if (!this.settings) {
        console.warn('FrontBackImageHelperSkuLevel: No settings found');
        return;
      }

      this.frontInput = this.querySelector('[data-select-front]');
      this.backInput = this.querySelector('[data-select-back]');

      if (!this.frontInput && !this.backInput) {
        console.warn('FrontBackImageHelperSkuLevel: No input elements found');
        return;
      }

      this.setEventListeners();
      this.isInitialized = true;
    }

    setEventListeners() {
      document.addEventListener('product-option-change', this.handleProductOptionChange.bind(this));
    }

    handleProductOptionChange(event) {
      if (!this.isInitialized) {
        console.warn('FrontBackImageHelperSkuLevel: Component not initialized');
        return;
      }

      const { variant } = event.detail;
      if (!variant) {
        console.warn('FrontBackImageHelperSkuLevel: No variant in event');
        return;
      }

      this.updateInputsForVariant(variant);
    }


    updateInputsForVariant(variant) {
      const currentVariantObject = this.settings[variant.id];

      if (!currentVariantObject) {
        console.warn('FrontBackImageHelperSkuLevel: No variant object found');
        return;
      }

      this.frontInput.value = currentVariantObject.frontImage || '';
      this.backInput.value = currentVariantObject.backImage || '';
    }
  }

  customElements.define(customElements.component_sku_level, FrontBackImageHelperSkuLevel);
}